import { NgModule } from '@angular/core';

import { AutoresizeDirective } from './autoresize/autoresize';
import { CountUpDirective } from './count-up/count-up';

@NgModule({
  declarations: [CountUpDirective, AutoresizeDirective],
  imports: [],
  exports: [CountUpDirective, AutoresizeDirective],
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts